import { Utils } from "@app-services/utils.service";
import { ContextType } from "@enums/context-type.enum";

let ctxType: ContextType | undefined = undefined;
let sessionId: string = Utils.getUnsecuredGuid();

export function getContextType(): ContextType {
    if (ctxType) {
        return ctxType;
    }

    throw Error("Context type unavailable");
}

export function setContextType(contextType: ContextType): void {
    ctxType = contextType;
}

export function getSessionId(): string {
    return sessionId;
}

export function setSessionId(sId: string) {
    sessionId = sId;
}